/* ============
 * Video Transformer
 * ============
 *
 * The transformer for the video.
 */

import Transformer from './Transformer';

export default class VideoTransformer extends Transformer {
  /**
   * Method used to transform a fetched video.
   *
   * @param video The fetched video.
   *
   * @returns {Object} The transformed video.
   */
  static fetch(video) {
    return {
      id: video.id,
      title: video.snippet.title,
      description: video.snippet.description,
      image: video.snippet.thumbnails.medium.url,
      image_all: video.snippet.thumbnails,
      privacyStatus: video.status.privacyStatus,
      views: video.statistics.viewCount,
      likes: video.statistics.likeCount,
      dislikes: video.statistics.dislikeCount
    };
  }

  /**
   * Method used to transform a send account.
   *
   * @param account The account to be send.
   *
   * @returns {Object} The transformed account.
   */
  static send(account) {
    return {
      email: account.email,
      first_name: account.firstName,
      last_name: account.lastName,
    };
  }
}
